import { render, staticRenderFns } from "./addDriverPromote.vue?vue&type=template&id=a48fa768&scoped=true&"
import script from "./addDriverPromote.vue?vue&type=script&lang=js&"
export * from "./addDriverPromote.vue?vue&type=script&lang=js&"
import style0 from "./addDriverPromote.vue?vue&type=style&index=0&id=a48fa768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48fa768",
  null
  
)

export default component.exports